import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
/* eslint-disable  import/no-cycle */
import { RootState } from 'store/rootReducer';
import { i18n } from 'helpers/i18n';
import { Preview, UpdatePreviewPayload, PreviewParams } from './qrPreviewTypes';
import { axiosInstance } from '../axiosInstance';

const previewsApiPrefix = '/preview/qr';

export type PreviewsState = {
  content: Preview;
  error: string;
  isLoading: boolean;
};

const initialState: PreviewsState = {
  content: {
    data: [],
    is_public: false,
    related_resources: []
  },
  isLoading: false,
  error: ''
};

export const fetchQRPreview = createAsyncThunk<UpdatePreviewPayload, PreviewParams, { rejectValue: string }>(
  'previews/qr',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(previewsApiPrefix, { params });
      if (!response.data.is_public) {
        return rejectWithValue(i18n.t('preview.private qr'));
      }

      return { isLoading: false, preview: response.data };
    } catch (err) {
      return rejectWithValue(i18n.t('preview.error'));
    }
  }
);

const previewsSlice = createSlice({
  initialState,
  name: 'previews',
  reducers: {
    resetPreview: state => {
      state.isLoading = false;
      state.content = { data: [], related_resources: [], is_public: false };
      state.error = '';
    }
  },
  extraReducers: builder =>
    builder
      .addCase(fetchQRPreview.fulfilled, (state, { payload }: PayloadAction<UpdatePreviewPayload>) => {
        const { isLoading, preview } = payload;
        state.isLoading = isLoading;
        state.content = preview;
        state.error = '';
      })
      .addCase(fetchQRPreview.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchQRPreview.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.content = { data: [], related_resources: [], is_public: false };
        state.error = payload || i18n.t('preview.error');
      })
});

const { actions, reducer } = previewsSlice;
export { reducer as preview };
export const { resetPreview } = actions;

export const getPreview = (state: RootState) => state.preview.content;
export const isLoading = (state: RootState) => state.preview.isLoading;
export const getError = (state: RootState) => state.preview.error;
